import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateStaffContactInfo } from "../../../redux/slice/staff/staffSlice";
import useInputChange from "../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../utils/validators/validators";
import Form from "../../form/Form";
import PhoneInput from "react-phone-number-input";

const ContactInfo = () => {
  const { user_permissions } = useSelector((state) => state.auth?.user);
  // fetch records from redux state
  const { contact_information } = useSelector(
    (state) => state?.staff.staff_information
  );

  const dispatch = useDispatch();

  const [hasEditStaff, setHasEditStaff] = useState();
  const [contactInfo, setContactInfo] = useState({});
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});

  const [phoneNumber, setPhoneNumber] = useState(contact_information?.phone_no);
  const [homeNumber, setHomeNumber] = useState(
    contact_information?.home_number
  );
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("#fa5c7c");
      setErrorMessage("Please enter phone number");
    } else {
      setBorderColor("");
      setErrorMessage("");
      setPhoneNumber(phone_no);
    }
    setStaffInputData({
      ...staffInputData,
      phone_no: phoneNumber,
      home_number: homeNumber,
    });
  };

  const handleHomeNumberChange = (value) => {
    setHomeNumber(value);
  };

  // Update Personal Info
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!phoneNumber) {
        setBorderColor("#fa5c7c");
        setErrorMessage("Please enter phone number");
        return;
      }
      dispatch(
        updateStaffContactInfo({
          ...staffInputData,
          phone_no: phoneNumber,
          home_number: homeNumber,
        })
      );
    }
  };

  // declare input fields variables
  const [staffInputData, setStaffInputData] = useState({
    email: contact_information?.email,
    contact_address: contact_information?.contact_address,
    home_address: contact_information?.home_address,
  });

  // Custom hook for input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  // initialize contact information
  useEffect(() => {
    setContactInfo(contact_information);
    if (contact_information) {
      setStaffInputData({
        ...staffInputData,
        phone_no: contactInfo?.phone_no,
        home_number: contactInfo?.home_number,
        email: contactInfo?.email,
        contact_address: contactInfo?.contact_address,
        home_address: contactInfo?.home_address,
        id: contactInfo?.id,
      });
    }
  }, [contact_information, editing]);

  useEffect(() => {
    setHasEditStaff(
      user_permissions?.some((permission) => permission.name === "edit staff")
    );
  }, [user_permissions]);

  return (
    <div className='border p-4 rounded-3 mt-4 px-3 position-relative'>
      <h4 className='fw-bold text-primary bg-white position-absolute profile-title'>
        Contact Information
      </h4>
      {contact_information ? (
        <Form
          setError={setError}
          submitHandler={handleSubmit}
          values={staffInputData}
        >
          <div className='row'>
            <div className='col-md-12 mb-3 px-2 py-2 shadow-lg'>
              <div className='row'>
                <div className='col-xs-6 col-sm-6 col-md-4 px-3'>
                  <h5>Phone Number</h5>
                  {!editing && <p>{contact_information?.phone_no}</p>}

                  {editing && (
                    <div className='custom-prefix position-relative'>
                      <PhoneInput
                        placeholder='Enter phone number'
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        onBlur={(e) => {
                          if (!e.target.value) {
                            setBorderColor("#fa5c7c");
                            setErrorMessage("Please enter phone number");
                          } else {
                            setBorderColor("");
                            setErrorMessage("");
                          }
                        }}
                        defaultCountry={null}
                        className='form-control custom-phone-input'
                        style={{ borderColor: `${borderColor}` }}
                      />
                      {errorMessage && (
                        <span
                          className='text-danger'
                          style={{ fontSize: "12px" }}
                        >
                          {errorMessage}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className='col-xs-6 col-sm-6 col-md-4'>
                  <h5>Home Number</h5>
                  {!editing && <p>{contact_information?.home_number}</p>}
                  {editing && (
                    <div className='custom-prefix position-relative'>
                      <PhoneInput
                        placeholder='Enter phone number'
                        value={homeNumber}
                        onChange={handleHomeNumberChange}
                        defaultCountry={null}
                        className='form-control custom-phone-input'
                      />
                    </div>
                  )}
                </div>
                <div className=' col-sm-6 col-md-4 px-3'>
                  <h5>Email Address</h5>
                  {!editing && <p>{contact_information?.email}</p>}
                  {editing && (
                    <input
                      className={`form-control update-input ${
                        error.email && "is-invalid"
                      }`}
                      textname='email'
                      type='email'
                      name='email'
                      value={input.email || contact_information?.email}
                      onChange={handleChange}
                      id='email'
                      placeholder='Email'
                    />
                  )}
                  {error.email && (
                    <span className='invalid-feedback'>{error.email}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 py-2 bg-body shadow-lg'>
              <div className='row'>
                <div className='col-sm-6 col-md-6 px-3'>
                  <h5>Contact Address</h5>
                  {!editing && <p>{contact_information?.contact_address}</p>}
                  {editing && (
                    <textarea
                      className={`form-control update-input ${
                        error.contact_address && "is-invalid"
                      }`}
                      textname='contact address'
                      name='contact_address'
                      value={
                        input.contact_address ||
                        contact_information?.contact_address
                      }
                      onChange={handleChange}
                      id='contact_address'
                      placeholder='Contact Address'
                      rows={6}
                    ></textarea>
                  )}
                  {error.contact_address && (
                    <span className='invalid-feedback'>
                      {error.contact_address}
                    </span>
                  )}
                </div>
                <div className='col-sm-6 col-md-6 px-3'>
                  <h5>Home Address</h5>
                  {!editing && <p>{contact_information?.home_address}</p>}
                  {editing && (
                    <textarea
                      className={`form-control update-input ${
                        error.home_address && "is-invalid"
                      }`}
                      textname='home address'
                      name='home_address'
                      value={
                        input.home_address || contact_information.home_address
                      }
                      onChange={handleChange}
                      id='home_address'
                      placeholder='Home Address'
                      rows={6}
                    ></textarea>
                  )}
                  {error.home_address && (
                    <span className='invalid-feedback'>
                      {error.home_address}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          {hasEditStaff && (
            <div className='row'>
              <div className='d-flex justify-content-end'>
                <div>
                  <a
                    className={`btn btn-${
                      editing ? "warning" : "info"
                    } btn-sm mt-3 px-4 text-white`}
                    onClick={() => {
                      setEditing(editing ? false : true);
                      setBorderColor("");
                      setErrorMessage("");
                      // setError({...{}, })
                    }}
                  >
                    {editing ? "Close" : "Edit"}
                  </a>
                  {editing && (
                    <button className='btn btn-success ms-2 btn-sm mt-3 px-4'>
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </Form>
      ) : (
        <div className='alert alert-info'>No Record Found</div>
      )}
    </div>
  );
};

export default ContactInfo;
